import { render, staticRenderFns } from "./StreamingNewWSPlayer.vue?vue&type=template&id=3abe748b&scoped=true"
import script from "./StreamingNewWSPlayer.vue?vue&type=script&lang=js"
export * from "./StreamingNewWSPlayer.vue?vue&type=script&lang=js"
import style0 from "./StreamingNewWSPlayer.vue?vue&type=style&index=0&id=3abe748b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe748b",
  null
  
)

export default component.exports